/**
 * 技术成果管理控制器
 */
export default class TechAchievementController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techAchievement/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techAchievement/view', 'get', params, axiosOption, httpOption);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techAchievement/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techAchievement/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techAchievement/delete', 'post', params, axiosOption, httpOption);
  }

  static importData (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techAchievement/import', 'post', params, axiosOption, httpOption);
  }
}
